import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import ToolTip from '../Tooltip/Tooltip'

const ButtonWithTooltip = ({
    variant,
    text,
    icon,
    className,
    disabled,
    isOffline,
    position = 'bottom',
    width = 'full',
    ...rest
}) => {
    const [isHovered, setIsHovered] = useState(false)

    return (
        <div
            className={clsx('relative inline-block', `w-${width}`)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <button
                {...rest}
                className={clsx(className, variant)}
                disabled={disabled}
            >
                {icon && icon}
                {text}
            </button>

            {isHovered && isOffline && (
                <ToolTip
                    position={position}
                    text="This feature requires an internet connection"
                />
            )}
        </div>
    )
}

ButtonWithTooltip.propTypes = {
    variant: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    isOffline: PropTypes.bool,
    position: PropTypes.oneOf(['bottom', 'top', 'left', 'right']),
    width: PropTypes.string,
}

export default ButtonWithTooltip
